export const routesTanitim = [
  {
    path: "/sube-list",
    name: "sube-list",
    component: () => import("@/views/sube/index.vue"),
    meta: {
      public: false,
      title: "Şube",
      yetki: { k: [2002202] },
    },
  },
]
